export default {
  CANCELLED: 'cancelled',
  SUGGESTED: 'suggested',
  CONFIRMED: 'confirmed',
}